<template>
  <b-row :class="{'justify-content-center' : !is_addt_srv}" no-gutters>
    <b-col cols="12" :sm="!is_addt_srv ? '8' : '12'" :md="!is_addt_srv ? '6' : '12'" :lg="!is_addt_srv ? '14' : '12'" :xl="!is_addt_srv ? '4' : '12'" class="bg-white" :class="{'fit-to-screen' : !is_addt_srv}">
      <div class="w-100 bg-white">
        <div class="w-100 py-5" v-if="error != ''">
          <ErrorMessage :message="error" />
        </div>
        <template v-else> 
          <template v-if="is_load">
            <div class="w-100 mb-3">
              <b-skeleton-img no-aspect height="250px"></b-skeleton-img>
            </div>
            <div class="ga-container">
              <div class="mb-3 pb-3 border-b-form">
                <b-skeleton width="70%" height="27px" class="mb-2"></b-skeleton>
                <b-skeleton width="100%" height="21px" class="mb-1"></b-skeleton>
                <b-skeleton width="50%" height="21px" class="mb-2"></b-skeleton>
                <b-skeleton width="30%" height="27px"></b-skeleton>
              </div>
              <div class="w-100">
                <b-skeleton width="40%" height="27px" class="mb-3"></b-skeleton>
                <b-skeleton type="input" height="65px"></b-skeleton>
              </div>
              <div class="w-100 position-absolute bg-white py-3 border-t-form" style="bottom: 0px;left:0px">
                <div class="ga-container">
                  <b-skeleton width="100%" height="52px"></b-skeleton>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <!-- IMG -->
            <div class="w-100 position-relative" style="height: 250px;">
              <img :src="detail_product.image_url" class="img-fit">
            </div>
    
            <!-- NAVBAR -->
            <div class="w-100 my-2" :class="is_addt_srv?'close-btn-popup':'close-btn-page'">
              <div class="ga-container">
                <div class="pos-close-button cursor-pointer" @click="backButton()">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_587_22)">
                      <path
                        d="M0.228308 13.7716C0.537114 14.0717 1.04885 14.0717 1.34883 13.7716L6.99557 8.12491L12.6423 13.7716C12.9423 14.0717 13.4629 14.0805 13.7628 13.7716C14.0628 13.4629 14.0628 12.9599 13.7628 12.66L8.1161 7.0044L13.7628 1.35766C14.0628 1.05767 14.0717 0.545937 13.7628 0.245954C13.454 -0.0628521 12.9423 -0.0628521 12.6423 0.245954L6.99557 5.8927L1.34883 0.245954C1.04885 -0.0628521 0.528291 -0.0716751 0.228308 0.245954C-0.0716751 0.55476 -0.0716751 1.05767 0.228308 1.35766L5.87505 7.0044L0.228308 12.66C-0.0716751 12.9599 -0.0804984 13.4717 0.228308 13.7716Z"
                        fill="black" fill-opacity="0.85" />
                    </g>
                    <defs>
                      <clipPath id="clip0_587_22">
                        <rect width="13.9911" height="14" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </div>
            </div>
    
            <!-- MAIN INFORMATION -->
            <div class="w-100 py-4 mb" :class="{
              'main-content-popup': is_addt_srv
            }">
              <div class="ga-container">
                <!-- BASIC INFORMATION -->
                <div class="w-100 mb-4 pb-4 border-b-semi-grey">
                  <p class="mb-1 sub-heading-1-2">{{ detail_product.name }}</p>
                  <p class="mb-1 body-2-2">{{ detail_product.description }}</p>
                  <p v-if="!is_variant" class="mb-0 text-16 font-lato">{{ $formatCurrency(detail_product.price.price_sell_final_with_tax_service) }} <span class="mb-0 ml-1 text-14 font-lato-regular text-semi-light text-line-through" v-if="detail_product.price.promotion_amount > 0">{{ $formatCurrency(detail_product.price.price_sell_base) }}</span></p>
                </div>
    
                <!-- NOTE -->
                <div 
                v-if="!is_variant"
                  class="w-100" 
                  :class="{
                    'mb-4 pb-4 border-b-semi-grey': is_variant
                  }">
                  <p class="mb-2 body-1-4">Add notes to your food</p>
                  <div class="w-100">
                    <textarea class="form-control body-2-2 mb-0" rows="2" v-model="notes"
                      placeholder="Add your special request"></textarea>
                  </div>
                </div>
    
                <!-- VARIANT -->
                <div class="w-100" v-if="is_variant">
                  <p class="mb-3 body-1-4">Choose variant</p>
    
                  <div class="w-100 mb-3 p-3 bg-white box-shadow-light-aff border-form radius-6"
                    v-for="(variant,variant_i) in detail_product.variant_list">
                    <div class="row no-gutters align-items-center">
                      <div class="col-7">
                        <div class="pr-3">
                          <p class="mb-0 body-2">{{ variant.name }}</p>
                          <p class="mb-0 text-12 font-lato-regular text-semi-light text-line-through" v-if="variant.price.promotion_amount > 0">{{ $formatCurrency(variant.price.price_sell_base) }}</p>
                          <p class="mb-0 text-14 font-lato">{{ $formatCurrency(variant.price.price_sell_final_with_tax_service) }}</p>
                        </div>
                      </div>
                      <div class="col-5">
                        <div class="row no-gutters align-items-center">
                          <div class="col-4 lh-1">
                            <div class="pos-order-qty border-green" @click="changeVariantQty('minus',variant_i)">
                              <svg width="16" height="3" viewBox="0 0 16 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16 2.28571H0V0H16V2.28571Z" class="fill-primary" />
                              </svg>
                            </div>
                          </div>
                          <div class="col-4 lh-1 text-center">
                            <p class="mb-0 font-lato text-16">{{ variant_data[variant_i].qty }}</p>
                          </div>
                          <div class="col-4 lh-1">
                            <div class="pos-order-qty border-green ml-auto" @click="changeVariantQty('plus',variant_i)">
                              <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M16 9.14286H9.14286V16H6.85714V9.14286H0V6.85714H6.85714V0H9.14286V6.85714H16V9.14286Z"
                                  class="fill-primary" />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12" v-if="variant_data[variant_i].qty > 0">
                        <div class="w-100 border-t-form-2-dashed mt-3 pt-2">
                          <div class="row no-gutters">
                            <div class="col-1 lh-1 align-self-center">
                              <svg class="lh-1" width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M2.01525 13.9142H10.7822C12.1236 13.9142 12.7911 13.2467 12.7911 11.9246V4.08825C12.7911 2.76615 12.1236 2.09868 10.7822 2.09868H2.01525C0.673889 2.09868 0 2.75973 0 4.08825V11.9246C0 13.2531 0.673889 13.9142 2.01525 13.9142ZM1.91898 12.8809C1.34778 12.8809 1.0333 12.5793 1.0333 11.9824V5.9302C1.0333 5.33976 1.34778 5.0317 1.91898 5.0317H10.8656C11.4368 5.0317 11.7578 5.33976 11.7578 5.9302V11.9824C11.7578 12.5793 11.4368 12.8809 10.8656 12.8809H1.91898Z"
                                  fill="black" fill-opacity="0.85" />
                                <path
                                  d="M3.03571 11.2828H7.31652C7.54111 11.2828 7.7144 11.116 7.7144 10.8977C7.7144 10.6731 7.54111 10.4934 7.31652 10.4934H3.03571C2.79825 10.4934 2.63138 10.6731 2.63138 10.8977C2.63138 11.116 2.79825 11.2828 3.03571 11.2828Z"
                                  fill="black" fill-opacity="0.85" />
                                <path
                                  d="M3.03571 9.35099H9.77461C9.99921 9.35099 10.1725 9.18412 10.1725 8.96593C10.1725 8.73487 9.99921 8.56158 9.77461 8.56158H3.03571C2.79825 8.56158 2.63138 8.73487 2.63138 8.96593C2.63138 9.18412 2.79825 9.35099 3.03571 9.35099Z"
                                  fill="black" fill-opacity="0.85" />
                                <path
                                  d="M3.03571 7.4192H9.77461C9.99921 7.4192 10.1725 7.23951 10.1725 7.01486C10.1725 6.79667 9.99921 6.62979 9.77461 6.62979H3.03571C2.79825 6.62979 2.63138 6.79667 2.63138 7.01486C2.63138 7.23951 2.79825 7.4192 3.03571 7.4192Z"
                                  fill="black" fill-opacity="0.85" />
                                <path
                                  d="M12.284 16C14.5367 16 16.4172 14.1195 16.4172 11.8604C16.4172 9.58846 14.556 7.72086 12.284 7.72086C10.012 7.72086 8.14442 9.59486 8.14442 11.8604C8.14442 14.1388 10.0056 16 12.284 16Z"
                                  fill="white" />
                                <path
                                  d="M12.284 15.1208C14.0489 15.1208 15.5443 13.6446 15.5443 11.8604C15.5443 10.0698 14.0682 8.60008 12.284 8.60008C10.4934 8.60008 9.0237 10.0762 9.0237 11.8604C9.0237 13.6575 10.4934 15.1208 12.284 15.1208Z"
                                  fill="black" fill-opacity="0.85" />
                                <path
                                  d="M12.284 13.9013C12.0466 13.9013 11.8925 13.7473 11.8925 13.5099V12.2519H10.6346C10.4036 12.2519 10.2431 12.0979 10.2431 11.8604C10.2431 11.623 10.4036 11.4689 10.6346 11.4689H11.8925V10.211C11.8925 9.97999 12.0466 9.81952 12.284 9.81952C12.5215 9.81952 12.6755 9.97999 12.6755 10.211V11.4689H13.927C14.1645 11.4689 14.3249 11.623 14.3249 11.8604C14.3249 12.0979 14.1645 12.2519 13.927 12.2519H12.6755V13.5099C12.6755 13.7473 12.5215 13.9013 12.284 13.9013Z"
                                  fill="white" />
                              </svg>
                            </div>
                            <div class="col-11 lh-1 align-self-center" style="padding-top: 3px;" @click="toggleNoteVariant(variant_i)">
                              <p v-if="variant_data[variant_i].notes == ''" class="body-3-3-1 mb-0 w-100 font-italic cursor-pointer text-underline-dashed">Add notes</p>
                              <p v-else class="body-2-1 mb-0 w-100">{{ variant_data[variant_i].notes }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
    
            <block :height="85"></block>
            <div class="w-100 bg-white py-3 border-t-form add-btn-popup">
              <div class="ga-container">
                <div class="row align-items-center">
                  <div class="col-5 lh-1" v-if="!is_variant">
                    <div class="row no-gutters align-items-center">
                      <div class="col-4 lh-1">
                        <div class="pos-order-qty border-green" @click="changeQty('minus')">
                          <svg width="16" height="3" viewBox="0 0 16 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16 2.28571H0V0H16V2.28571Z" class="fill-primary" />
                          </svg>
                        </div>
                      </div>
                      <div class="col-4 lh-1 text-center">
                        <p class="mb-0 font-lato text-16">{{ qty  }}</p>
                      </div>
                      <div class="col-4 lh-1">
                        <div class="pos-order-qty border-green ml-auto" @click="changeQty('plus')">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16 9.14286H9.14286V16H6.85714V9.14286H0V6.85714H6.85714V0H9.14286V6.85714H16V9.14286Z"
                              class="fill-primary" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="lh-1" :class="!is_variant ? 'col-7' : 'col-12'">
                    <state-button :click="saveToCart" size="lg" block variant="primary">{{ save_btn_txt }}</state-button>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </template>
    
        <popup-detail 
          id_ref="variant_note"
          direction="bottom" 
          :show="variant_notes.show"
          use_max_size
          wrapper_size="mobile"
          use_footer
          no_close_backdrop
          title="Add notes to your food"
          @close="toggleNoteVariant()">
          <template v-slot:body>
            <div class="w-100 px-3 py-4 border-t-form" v-if="variant_notes.show">
              <textarea ref="variant_note_form" class="form-control body-2-2 mb-0" rows="4" v-model="variant_notes.form"
                placeholder="Add your special request" @keyup.enter="saveNoteFromEnter"></textarea>
            </div>
          </template>
          <template v-slot:footer>
            <div class="px-3 pt-3">
              <state-button ref="save_note_btn" variant="primary" size="lg" :click="saveNote" block>Save</state-button>
            </div>
          </template>
        </popup-detail>
      </div>
    </b-col>
  </b-row>
</template>

<script>
  import {
    mapGetters,
    mapMutations
  } from 'vuex'
  import {
    get
  } from '@/services/index.js'

  export default {
    props:{
      page_module:{
        type: String,
        default: 'outlet'
      },
      detail_data:{
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        is_load: true,
        error: '',
        general_data: {},
        detail_product: {},
        notes: '',
        qty: 1,
        variant_data: [],
        variant_notes: {
          show: false,
          index: -1,
          form: ''
        }
      }
    },
    metaInfo() {
      return {
        title: this.page_title,
        titleTemplate: this.getMetaTitleTemplate
      }
    },
    computed: {
      ...mapGetters(['getMerchant','getOutletTrxProducts','getOutletTrxPromoCode','getMetaTitleTemplate']),
      is_addt_srv(){
        return this.page_module == 'additional_service'
      },
      pos_id() {
        if(this.is_addt_srv) return this.detail_data.pos_id
        return this.$route.query.pos_id
      },
      pos_code() {
        if(this.is_addt_srv) return ''
        return this.$route.params.pos_code
      },
      product_id() {
        if(this.is_addt_srv) return this.detail_data.product_id
        return this.$route.params.product_id
      },
      is_variant() {
        return this.detail_product.variant_list && this.detail_product.variant_list.length > 0 ? true : false
      },
      product_cart_index(){
        let index = -1
        if(this.detail_product.id) index = this.getOutletTrxProducts.findIndex(x=>x.product_data.id == this.detail_product.id)
        return index
      },
      save_btn_txt(){
        let text = 'Add to cart'
        if(!this.is_variant){
          let total_price = this.detail_product.price.price_sell_final_with_tax_service*this.qtys
          if(total_price > 0){
            text += ` - ${this.$formatCurrency(total_price)}`
          }else{
            if(this.product_cart_index != -1){
              text = this.qty == 0 ? 'Back to menu' : 'Update cart'
            }
          }
        }else{
          let total_price = 0
          this.detail_product.variant_list.forEach((variant,variant_i)=>{
            let total_x_qty = variant.price.price_sell_final_with_tax_service*this.variant_data[variant_i].qty
            total_price += total_x_qty
          })
          if(total_price > 0){
            text += ` - ${this.$formatCurrency(total_price)}`
          }else{
            if(this.product_cart_index != -1){
              text = 'Back to menu'
            }
          }
        }
        return text
      },
      page_title(){
        if(this.detail_product.id) return this.detail_product.name
        return ''
      }
    },
    mounted() {
      this.loadFirstData()
    },
    methods: {
      ...mapMutations(['setTrxOutletProduct','removeTrxOutletProduct']),
      loadFirstData() {
        this.is_load = true
        this.error = ''
        Promise.all([
            this.loadProductDetail()
          ])
          .catch(err => {
            this.error = err
          })
          .finally(() => {
            this.is_load = false
          })
      },
      loadProductDetail() {
        return new Promise((success, fail) => {
          get("CORE_HOTEL", `merchant-pos/${this.pos_id}/product/${this.product_id}`, {
            merchant_id: this.getMerchant.id,
            promo_code: this.getOutletTrxPromoCode
          }).then(response => {
            let res = response.data
            if (res.success) {
              this.detail_product = res.data
              this.getVuexData()
              success()
            } else {
              if(res.message = 'promo_code not found'){
                this.setTrxOutletPromoCode('')
                this.loadProductDetail().then(()=>success()).catch(next_err=>fail(next_err))
              }else{
                fail(res.message)
              }
            }
          })
        })
      },
      getVuexData(){
        if(!this.is_variant){
          if(this.product_cart_index != -1){
            let cart = this.getOutletTrxProducts[this.product_cart_index]
            this.notes = cart.notes
            this.qty = cart.qty
          }
        }else{
          this.variant_data = []
          this.detail_product.variant_list.forEach(item=>{
            let variant = {
              qty: 0,
              notes: '',
              is_cart: false
            }
            if(this.product_cart_index != -1){
              let product_cart = this.getOutletTrxProducts[this.product_cart_index]
              let variant_cart_index = product_cart.variants.findIndex(x=>x.variant_data.id == item.id)
              if(variant_cart_index != -1){
                variant = {
                  qty: product_cart.variants[variant_cart_index].qty,
                  notes: product_cart.variants[variant_cart_index].notes,
                  is_cart: true
                }
              }
            }
            this.variant_data.push(variant)
          })
        }
      },
      saveToCart() {
        return new Promise((success, fail) => {
          if(this.is_variant){
            this.variant_data.forEach((item,index)=>{
              let params_variant = {
                product: this.detail_product,
                variant: this.detail_product.variant_list[index],
                ref: 'variant',
                qty: item.qty,
                notes: item.notes,
                page_module: this.page_module
              }
              if(item.qty > 0) this.setTrxOutletProduct(params_variant)
              else if(item.qty == 0 && item.is_cart) this.removeTrxOutletProduct(params_variant)
            })
          }else{
            let params = {
              product: this.detail_product,
              variant: [],
              ref: 'product',
              qty: this.qty,
              notes: this.notes,
              page_module: this.page_module
            }
            
            if(this.qty > 0) this.setTrxOutletProduct(params)
            else this.removeTrxOutletProduct(params) 
          }

          setTimeout(()=>{
            this.backButton()
            success()
          },300)
        })
      },
      backButton() {
        if(this.is_addt_srv){
          this.$emit('close')
        }else{
          let route = {
            name: 'PosHome',
            params: {
              merchant_code: this.getMerchant.code,
              pos_code: this.pos_code
            }
          } 
  
          let route_query = this.$route.query
          if(route_query.from){
            route.name = route_query.from
            if(route_query.from == 'PosSearch'){
              route.query = {
                pos_id: this.pos_id
              }
            }
          }
          
          this.$router.push(route)
        }
      },
      changeQty(type) {
        if (type == 'minus' && this.qty > 0) {
          this.qty--
        }
        if (type == 'plus') {
          this.qty++
        }
      },
      changeVariantQty(type,index){
        if (type == 'minus' && this.variant_data[index].qty > 0) {
          this.variant_data[index].qty--
        }
        if (type == 'plus') {
          this.variant_data[index].qty++
        }
      },
      toggleNoteVariant(index=-1){
        this.variant_notes = {
          index: index,
          show: index != -1,
          form: index != -1 ? this.variant_data[index].notes : ''
        }
        if(index != -1){
          setTimeout(()=>{
            this.$refs.variant_note_form.focus()
          },100)
        }
      },
      saveNote(){
        return new Promise((success,fail)=>{
          setTimeout(()=>{
            this.variant_data[this.variant_notes.index].notes = this.variant_notes.form
            this.toggleNoteVariant()
            success()
          },300)
        })
      },
      saveNoteFromEnter(){
        this.$refs.save_note_btn.handleClick()
      }
    }

  }

</script>
<style>
  .pos-close-button {
    margin-left: auto;
    display: table;
    border-radius: 100%;
    height: 35px;
    width: 35px;
    text-align: center;
    display: grid;
    place-items: center;
    background-color: #fff;
  }

  .pos-order-qty {
    cursor: pointer;
    width: 35px;
    height: 35px;
    display: grid;
    place-items: center;
    text-align: center;
    border-radius: 6px;
  }
  .close-btn-page{
    position: fixed;
    top: 0px
  }
  .close-btn-popup{
    position: absolute;
    top: 0px
  }
  .add-btn-page{
    position: absolute;
    bottom: 0px
  }
  .add-btn-popup{
    position: absolute;
    bottom: 0px
  }

</style>



// WEBPACK FOOTER //
// src/pages/hotel/concierge/pos/ProductDetail.vue